import { api } from "./api";
import { INotification, NotificationFilters } from "../types/notification.type";

export const notificationApi = {
  // Получение уведомлений пользователя
  getNotifications: (filters?: NotificationFilters): Promise<{ notifications: INotification[] }> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString());
        }
      });
    }
    return api.get(`/notification?${params.toString()}`).then((response: any) => {
      const data = response.data || response;
      return data;
    });
  },

  // Получение количества непрочитанных уведомлений
  getUnreadCount: (): Promise<{ count: number }> => {
    return api.get("/notification/unread-count").then((response: any) => {
      const data = response.data || response;
      return data;
    });
  },

  // Отметить уведомление как прочитанное
  markAsRead: (notificationId: string): Promise<{ notification: INotification }> => {
    return api.put(`/notification/${notificationId}/read`).then((response: any) => {
      const data = response.data || response;
      return data;
    });
  },

  // Отметить все уведомления как прочитанные
  markAllAsRead: (): Promise<{ message: string }> => {
    return api.put("/notification/mark-all-read").then((response: any) => {
      const data = response.data || response;
      return data;
    });
  },

  // Удалить уведомление
  deleteNotification: (notificationId: string): Promise<{ message: string }> => {
    return api.delete(`/notification/${notificationId}`).then((response: any) => {
      const data = response.data || response;
      return data;
    });
  }
}; 